import {formActionTypes} from "../settings/types";

const initialState = {
    editMode        : false,
    disableInputs   : false,
    saveSuccess     : false,
    resetCombos     : false,
    domainObject    : null,
}

const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case formActionTypes.clearState:
            return initialState
        case formActionTypes.resetCombos:
            return {
                ...state,
                resetCombos: action.payload
            }
        case formActionTypes.domainObject:
            return {
                ...state,
                domainObject: action.payload
            }
        case formActionTypes.langs:
            return {
                ...state,
                domainObject: {
                    ...state.domainObject,
                    langs : action.payload
                }
            }
        case formActionTypes.secondaryLangs:
            return {
                ...state,
                domainObject: {
                    ...state.domainObject,
                    secondaryLangs : action.payload
                }
            }
        case formActionTypes.formData:
            return {
                ...state,
                editMode: action.payload.editMode,
                disableInputs: action.payload.disableInputs,
                saveSuccess: action.payload.saveSuccess
            }
        default:
            return state
    }
}

export default formReducer